export const IMAGES = 'images';



// WEBPACK FOOTER //
// ./src/constants/assetTypes.js